export default input => {
  if (!input) {
    return;
  }

  return input.replace(/-/g, " ");
};
